import { render, staticRenderFns } from "./new_fangwuGui.vue?vue&type=template&id=4f39e1d1&scoped=true&"
import script from "./new_fangwuGui.vue?vue&type=script&lang=js&"
export * from "./new_fangwuGui.vue?vue&type=script&lang=js&"
import style0 from "./new_fangwuGui.vue?vue&type=style&index=0&id=4f39e1d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39e1d1",
  null
  
)

export default component.exports